import { useState } from '@wordpress/element';
import { CloseButtonSVG } from '../../dashboard/icon';

export const addUtmMedium = (url, utmMedium) => {
    if (!url) return '';

    const normalizedUrl = /^[a-z][a-z\d+\-.]*:\/\//i.test(url) ? url : `https://${url}`;
    const separator = normalizedUrl.includes('?') ? '&' : '?';

    return `${normalizedUrl}${separator}utm_medium=${encodeURIComponent(utmMedium)}`;
};

const DiscountBanner = ({
    bannerData,
    showCloseButton = true,
    utmMedium = 'dashboard-discount-banner',
    onClose,
}) => {
    const [closed, setClosed] = useState(false);

    if (!bannerData?.banner) return null;

    const expired = bannerData?.expired ? new Date(bannerData.expired) : null;
    const isExpired = expired instanceof Date && !Number.isNaN(expired.getTime()) && new Date() > expired;

    if (closed || isExpired) return null;

    const handleClose = () => {
        if (typeof onClose === 'function') {
            onClose(setClosed);
            return;
        }

        setClosed(true);
    };

    return (
        <div className="jkit-discount-banner">
            <a href={addUtmMedium(bannerData?.url, utmMedium)} target="_blank" rel="noreferrer">
                <img src={bannerData?.banner} alt="event-banner" />
            </a>
            {showCloseButton && (
                <button onClick={handleClose} type="button" className="jkit-close-banner">
                    <CloseButtonSVG />
                </button>
            )}
        </div>
    );
};

export default DiscountBanner;
